import {useContext, useEffect, useState} from "react";
import {useQuery} from "@tanstack/react-query";
import {search} from "../../api/catalog";
import {ReducerStateInterface} from "../../interfaces/core/ReducerStateInterface";
import {GlobalContext, ReducerActionType} from "../../GlobalReducer";
import CatelogBase from "./CatalogBase";
import useLocalStorage from "../../utils/useLocalStorage";
import {LOCAL_STORAGE_KEY_SEARCH_STRING} from "../../Config";
import {RELEVANCE_SORT} from "../../utils/productSort";

export default function Search() {

    const [searchString, setSearchString] = useState<string>('');

    const [state, dispatch] = useContext<[ReducerStateInterface, Function]>(GlobalContext);

    const {getItems} = useLocalStorage()

    useEffect(() => {
        const searchString = getItems(LOCAL_STORAGE_KEY_SEARCH_STRING);
        if (searchString.length === 0) {
            return;
        }
        setSearchString(searchString[0] || '')
    }, [getItems(LOCAL_STORAGE_KEY_SEARCH_STRING), state.searchString]);

    const {data: response, status} = useQuery({
        queryKey: [searchString, state.customer?.id],
        queryFn: () => search(searchString, state.customer),
        //@ts-ignore
        retry: !window.NOSCRIPT ? false : 1,
        enabled: !!searchString
    })

    useEffect(() => {
        switch (status) {
            case 'pending':
                dispatch({type: ReducerActionType.LOAD})
                return;
            case 'error':
                dispatch({type: ReducerActionType.ERROR, payload: 'При загрузке товаров возникли ошибки'})
                return;
            case 'success':
                dispatch({type: ReducerActionType.SUCCESS})
                return;
        }
    }, [status]);

    useEffect(() => {
        dispatch({type: ReducerActionType.SET_BREADCRUMBS, payload: [{name: 'Результаты поиска по запросу: ' + searchString}]})
    }, [response]);


    return (<>{response && <CatelogBase response={response} header={'Результаты поиска по запросу: ' + searchString} baseUrl={'/search'} defaultSort={RELEVANCE_SORT} />}</>);
}